import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { rememberCatalogPosition } from '../lib/gameLaunch';

/** Legacy /games/:id links jump straight into the in-app play shell (no 3-button panel). */
export function GameDetailPage() {
  const { gameId } = useParams();

  useEffect(() => {
    rememberCatalogPosition('/games');
  }, []);

  if (!gameId) return <Navigate to="/games" replace />;
  return <Navigate to={`/play/${encodeURIComponent(gameId)}`} replace />;
}
